import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdEdit } from 'react-icons/md';
import toast from 'react-hot-toast';
import Skeleton from '../../../../components/Skeleton';
import TableTemplate from '../../../../components/table/index';
import { getAllScreeningQuestion } from '../../../../controllers/ScreeningQuestionController';

const TableComponent = ({ t }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    
    const columns = useMemo(() => [
        { field: 'type', title: t('common.type.title'), sortable: true },
        { field: 'sequence', title: t('common.sequence.title'), sortable: true },
        { field: 'updated_by', title: t('common.updated.by'), sortable: true },
        { field: 'updated_at', title: t('common.updated.title'), sortable: true }
    ], [t]);
    
    const actions = useMemo(() => [
        (row) => (
            <button
                className='focus:outline-none text-xl md:text-2xl text-secondary hover:text-primary focus:text-primary'
                title={t('common.action.edit')}
                onClick={() => navigate(`/screening-question/${row.id}/edit`)}
            >
                <MdEdit />
            </button>
        ),
    ], [ t, navigate ]);
    
    const filters = useMemo(() => [
        { field: 'type', label: t('common.type.title'), by: t('common.type.main'), labelBy: t('common.type.main'), mode: 'exact' },
        { field: 'type', label: t('common.type.title'), by: t('common.type.negative'), labelBy: t('common.type.negative'), mode: 'exact' }
    ], [t]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                const result = await getAllScreeningQuestion(t('languages.select'));
                const formattedRows = result.questions.map((question) => {
                    const formattedType = question.type.toLowerCase();
                    
                    return {
                        id: question.id,
                        type: t(`common.type.${formattedType}`),
                        sequence: question.sequence,
                        updated_by: question.updated_by,
                        updated_at: question.updated_at
                    };
                });
                
                setRows(formattedRows);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            };
        };
        
        fetchData();
    }, [t]);
    
    if (loading) {
        return (
        <Skeleton className='h-96 w-full rounded-lg' />
        );
    };
    
    return (
        <div>
            <TableTemplate
                rows={rows}
                columns={columns}
                actions={actions}
                filters={filters}
                fileName={t('menu.screeningQuestion')}
            />
        </div>
    );
};

export default TableComponent;
